<script lang="ts">
  import type { Place } from "../../types";
  import Timestamp from "../timestamp.svelte";

  export let place: Place;
  export let hours = [];

  $: totallyAmbiguous = place.startTimeIsAmbiguous && place.endTimeIsAmbiguous;
</script>

{#if hours.length > 0}
  {#if totallyAmbiguous}
    TBD
  {:else}
    {#each hours as time}
      <div>
        {#if place.startTimeIsAmbiguous}
          TBD
        {:else}
          <Timestamp time={time.from} />
        {/if}

        <span>&ndash;</span>

        {#if place.endTimeIsAmbiguous}
          TBD
        {:else}
          <Timestamp time={time.until} />
        {/if}
      </div>
    {/each}
  {/if}
{:else}
  Closed
{/if}
